function reloadShopsPageAndSwitchToHogastTab()
{
    localStorage.setItem("hogast_reload", "true");
    window.location.reload(true);
}

// Assign the function to the window object
window.reloadShopsPageAndSwitchToHogastTab = reloadShopsPageAndSwitchToHogastTab;